<script setup lang="ts">
import SecondaryDrawerHeader from "@/modules/explorer/components/SecondaryDrawer/SecondaryDrawerHeader.vue";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useApiClient } from "@/api/client";
import { useDashboardStore } from "@/modules/dashboards/store";
import { useBaseStore } from "@/stores/base";

const prompt = ref("");
const dashboardState = useDashboardStore().dashboardState;
const aiAnswer = ref("");
const loading = ref(false);

// async function pollAiReport(batchUuid: string) {
// 	const interval = setInterval(async () => {
// 		const response = await useApiClient("aiReport").getStatus(batchUuid);
// 		if (response.data.status === "completed") {
// 			aiAnswer.value = response.data.rapport;
// 			clearInterval(interval);
// 		}
// 	}, 2000);
// }

onBeforeUnmount(() => {
	useBaseStore().secondaryDrawerWidth = 400;
});

onMounted(() => {
	useBaseStore().secondaryDrawerWidth = 700;
});
async function generateAiReport() {
	loading.value = true;
	aiAnswer.value = "";
	const response = await useApiClient("aiReport").generateDashboardRapport(
		dashboardState.dashboard,
		dashboardState.dashboard.cards,
		prompt.value
	);
	prompt.value = "";
	aiAnswer.value = response.data.rapport;

	loading.value = false;
}
</script>

<template>
	<SecondaryDrawerHeader icon="fa: fa-duotone fa-brain" title="AI Report" />

	<div class="drawer-content pa-4">
		<v-textarea
			v-model="prompt"
			label="Optional Prompt"
			placeholder="E.g., Focus on trends, anomalies, or executive summary"
			rows="5"
			auto-grow
			variant="outlined"
			density="comfortable"
		/>

		<div class="d-flex justify-space-between align-center mt-4">
			<v-btn
				color="primary"
				size="large"
				block
				@click="generateAiReport"
				:disabled="loading"
			>
				<span v-if="!loading">Generate Report</span>
				<v-progress-circular v-else color="white" indeterminate size="24">
					Generating Report...
				</v-progress-circular>
			</v-btn>
		</div>

		<v-divider class="my-4"></v-divider>

		<div v-if="aiAnswer" class="report-output">
			<h3 class="text-h3 mb-2">Generated Report</h3>
			<v-card elevation="1" class="ai-report pa-4 rounded-lg bg-grey-lighten-4">
				<div class="ai-report__text">
					{{ aiAnswer }}
				</div>
			</v-card>
		</div>
	</div>
</template>

<style scoped lang="scss">
.ai-report {

}

.ai-report__text {
	white-space: pre-wrap;
	overflow-wrap: anywhere;
	line-height: 1.6;
	font-size: 0.95rem;
	color: rgba(0, 0, 0, 0.85);
}
</style>
